import { Link } from 'react-router-dom';
import { getLatestArticles } from '@/mocks/articles';

export default function LatestArticles() {
  const latestArticles = getLatestArticles(8);

  return (
    <section className="py-14 bg-background-50">
      <div className="container-custom">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg">
              <i className="ri-time-line text-primary-600 text-lg"></i>
            </div>
            <div>
              <h2 className="text-xl font-bold text-foreground-950 font-heading">最新文章</h2>
              <p className="text-sm text-foreground-500">实时更新的精彩内容</p>
            </div>
          </div>
          <Link
            to="/category/tech-discuss"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            全部文章 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {latestArticles.map((article) => (
            <article key={article.id} className="bg-background-100 border border-background-200/70 rounded-lg p-5 hover:border-primary-300 transition-all group">
              <div className="flex items-center gap-2 mb-2.5 flex-wrap">
                <Link
                  to={`/category/${article.categoryId}`}
                  className="text-xs px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded-full hover:bg-secondary-200 transition-colors font-medium"
                >
                  {article.categoryName}
                </Link>
                {article.isHot && (
                  <span className="text-xs px-2 py-0.5 bg-accent-100 text-accent-700 rounded-full font-medium">
                    热门
                  </span>
                )}
              </div>
              <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 leading-snug font-heading">
                <Link to={`/article/${article.id}`} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                  {article.title}
                </Link>
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                {article.excerpt}
              </p>
              <div className="flex items-center justify-between text-xs text-foreground-500">
                <div className="flex items-center gap-2">
                  <img
                    src={article.authorAvatar}
                    alt={article.author}
                    className="w-5 h-5 rounded-full object-cover"
                    width="20"
                    height="20"
                  />
                  <span className="text-foreground-700">{article.author}</span>
                  <span>·</span>
                  <span>{article.publishDate}</span>
                </div>
                <div className="flex items-center gap-3">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line text-[10px]"></i>{article.readCount.toLocaleString()}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line text-[10px]"></i>{article.commentCount}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}